import { render } from "./Resume.vue?vue&type=template&id=3b4284ee"
import script from "./Resume.vue?vue&type=script&lang=js"
export * from "./Resume.vue?vue&type=script&lang=js"

import "./Resume.vue?vue&type=style&index=0&id=3b4284ee&lang=scss"

import exportComponent from "/opt/render/project/src/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__